export default "__VITE_ASSET__PX7RNwPA__"